import { toCurrentApp } from 'config/app';

interface LogoWithTextProps {
  className?: string;
}

const Logo = toCurrentApp({
  voceopina: ({ className }: LogoWithTextProps) => (
    <svg width="110" height="110" viewBox="0 0 110 110" fill="none" className={className}>
      <rect
        x="0.5"
        y="0.5"
        width="109"
        height="109"
        rx="54.5"
        fill="url(#paint0_linear_9459_8789)"
      />
      <path
        d="M93 55C93 32.8879 76.0062 15 55 15C33.9938 15 17 32.8879 17 55C17 77.1121 33.9938 95 55 95C63.4969 95 71.2872 92.1434 77.6573 87.1747L87.8053 90.5289L84.7375 79.9687C89.8132 73.0133 93 64.4397 93 55ZM55.2344 80.341L25.7313 37.4843H42.6062L55.2344 55.7446L67.7436 37.4843H83.4397L55.2344 80.341Z"
        fill="#4D77F3"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9459_8789"
          x1="52.384"
          y1="0.770371"
          x2="52.384"
          y2="109.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.182292" stopColor="#E9F2FF" />
          <stop offset="1" stopColor="#D9E6FA" />
        </linearGradient>
      </defs>
    </svg>
  ),

  queopinas: ({ className }: LogoWithTextProps) => (
    <svg width="109" height="109" viewBox="0 0 109 109" fill="none" className={className}>
      <rect width="109" height="109" rx="54.5" fill="url(#paint0_linear_10069_13287)" />
      <path
        d="M65.4127 53.49C65.4127 60.7492 63.6163 66.9373 59.9038 69.9123V66.2232H49.7241V70.0313C45.7721 67.2943 44.2152 60.8682 44.2152 53.49C44.2152 43.4938 48.1673 35.4017 54.8738 35.4017C61.4606 35.4017 65.4127 43.4938 65.4127 53.49Z"
        fill="url(#paint1_linear_10069_13287)"
      />
      <path
        d="M94.1667 54.5C94.1667 32.5821 76.4179 14.8333 54.5 14.8333C32.5821 14.8333 14.8333 32.5821 14.8333 54.5C14.8333 76.4179 32.5821 94.1667 54.5 94.1667C63.3148 94.1667 71.534 91.3078 78.0856 86.3048L88.6872 89.6401L85.471 79.1577C90.9505 72.487 94.1667 63.7913 94.1667 54.5ZM59.8604 75.3458V81.3018H49.7352V75.465C39.1336 73.3208 31.1527 64.1486 31.1527 53.1897C31.1527 40.5631 41.6351 30.4379 54.6191 30.4379C67.6031 30.4379 78.0856 40.6822 78.0856 53.1897C78.0856 63.9104 70.3428 72.9635 59.8604 75.3458Z"
        fill="url(#paint2_linear_10069_13287)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10069_13287"
          x1="51.884"
          y1="0.270371"
          x2="51.884"
          y2="109.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.182292" stopColor="#E9F2FF" />
          <stop offset="1" stopColor="#D9E6FA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10069_13287"
          x1="54.8139"
          y1="35.4017"
          x2="54.8139"
          y2="70.0313"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4D77F4" />
          <stop offset="1" stopColor="#2E5BE0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10069_13287"
          x1="54.5"
          y1="14.8333"
          x2="54.5"
          y2="94.1667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4D77F4" />
          <stop offset="1" stopColor="#2E5BE0" />
        </linearGradient>
      </defs>
    </svg>
  ),

  quedices: ({ className }: LogoWithTextProps) => (
    <svg width="109" height="109" viewBox="0 0 109 109" fill="none" className={className}>
      <rect width="109" height="109" rx="54.5" fill="url(#paint0_linear_10069_13320)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.5163 78.7772C92.9688 71.9835 96.2308 63.3564 96.2308 53.9674C96.2308 32.0602 78.4714 14.3008 56.5641 14.3008C34.6568 14.3008 16.8975 32.0602 16.8975 53.9674C16.8975 75.8747 34.6568 93.6341 56.5641 93.6341C65.3791 93.6341 73.5225 90.7588 80.1076 85.8948L91.1322 89.6681L87.5163 78.7772ZM68.6261 70.2716C76.5388 70.2716 83.2874 65.5121 86.0458 58.8211C86.0746 58.7457 86.1039 58.6728 86.1331 58.6C86.1623 58.5271 86.1915 58.4543 86.2204 58.3789C86.2309 58.3473 86.2414 58.3264 86.2519 58.3055L86.2559 58.2975C87.0591 56.2846 87.4894 54.0972 87.4894 51.8285C87.4877 41.8436 79.1091 33.6514 68.7413 33.6514C68.5092 33.6514 56.6046 33.6514 56.3725 33.6632V36.6995C60.9574 40.2373 63.8887 45.7067 63.8887 51.8268C63.8887 57.9468 61.0032 63.3925 56.3369 66.9659L56.3725 70.2479C56.6046 70.2597 68.3923 70.2716 68.6261 70.2716ZM64.4139 37.5603C66.4425 37.5603 68.1171 37.5522 68.7123 37.5494L68.9396 37.5484C72.3605 37.5484 74.8851 40.3288 76.2355 44.4953C76.2812 44.624 76.3287 44.7748 76.3643 44.9138C76.9234 46.9843 77.1911 49.3581 77.1911 51.9064C77.1911 59.9004 74.0498 66.3712 68.8243 66.3712C68.7193 66.3712 66.8233 66.3712 64.4139 66.3593V37.5603ZM56.3723 38.2007C60.2711 41.5403 62.7262 46.4167 62.7262 51.8268V51.8285C62.7262 57.2267 60.2711 62.0912 56.3723 65.4308C54.068 67.3844 51.2639 68.8161 48.1683 69.5261V74.2855H40.0811V69.6192C31.611 67.9079 25.2334 60.5764 25.2334 51.8268C25.2334 41.7385 33.612 33.6514 43.9798 33.6514C48.7393 33.6514 53.0667 35.3728 56.3723 38.2007ZM48.17 62.1946V65.1495H48.1716C51.1148 62.7639 52.5465 57.818 52.5465 52.0115C52.5465 44.0175 49.4983 37.5484 44.1679 37.5484C38.8374 37.5484 35.7079 44.0175 35.7079 52.0115C35.7079 57.9112 36.9414 63.0553 40.0828 65.2427V62.1946H48.17Z"
        fill="url(#paint1_linear_10069_13320)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10069_13320"
          x1="51.884"
          y1="0.270371"
          x2="51.884"
          y2="109.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.182292" stopColor="#E9F2FF" />
          <stop offset="1" stopColor="#D9E6FA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10069_13320"
          x1="16.8975"
          y1="53.9674"
          x2="96.2308"
          y2="53.9674"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4D77F4" />
          <stop offset="1" stopColor="#2C59DF" />
        </linearGradient>
      </defs>
    </svg>
  ),
});

export function LogoBubble({ className }: LogoWithTextProps) {
  return <Logo className={className} />;
}
